import React from "react";
import ProjectBanner from "../../layout/builders/ProjectBanner";
import Layout from "../../layout/realestateagent/Layout";
import CustomerQuery from "../../layout/realestateagent/CustomerQuery/CustomerQuery";

const CustomerQueryPage = () => {
    return (
        <div style={{ backgroundColor: "#E0E0E0" }}>
            <Layout>
                <div>
                    <ProjectBanner
                        title="Customer Enquiries"
                        subtitle="Manage customer queries and leads"
                        imageUrl="https://via.placeholder.com/1200x300"
                    />
                </div>
                <CustomerQuery />
            </Layout>
        </div>
    );
};

export default CustomerQueryPage;
